// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"668cc2ce","264":"9713082c","418":"040e8446","432":"98567a59","453":"e42d539d","480":"db3aae39","638":"184bfcc6"}[chunkId] + ".chunk.js";
};